import { usingGet } from '@ocean/api'

export const getVirtualEvent = (eventId: string) =>
  usingGet(`VirtualEvents/GetVirtualEvent?eventId=${eventId}`)
